import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPumpScrew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 50,
		rx: 50,
		ry: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 50.0 0.0 L 100.0 50.0 L 50.0 100.0 M 25.0 45.0 L 30.0 40.0 L 40.0 50.0 L 50.0 40.0 L 60.0 50.0 L 70.0 40.0 L 75.0 45.0 M 25.0 55.0 L 30.0 50.0 L 40.0 60.0 L 50.0 50.0 L 60.0 60.0 L 70.0 50.0 L 75.0 55.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgPumpScrew;
